export enum FollowerUpdateFrequency {
  NONE = 'NONE',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export const FOLLOWER_UPDATE_FREQUENCY_OPTIONS: readonly FollowerUpdateFrequency[] = [
  FollowerUpdateFrequency.NONE,
  FollowerUpdateFrequency.WEEKLY,
  FollowerUpdateFrequency.MONTHLY,
];

export interface EventsCalendarFollowerSettingsProps {
  doShowFollowButton: boolean;
  followerUpdateFrequency: FollowerUpdateFrequency;
  /** The calendar's follower mailing-list id, or null when no signup form exists yet. Drives the tooltip's "this mailing list" link. */
  mailingListId: string | null;
  onToggleFollowButton: (next: boolean) => void;
  onChangeFrequency: (next: FollowerUpdateFrequency) => void;
  onPreviewClick: () => void;
}
